module.exports = __webpack_public_path__ + "static/media/fdl.f0dd717c.png";